export const exploresEn = [
  "The current state of cybersecurity readiness across key sectors",
  "How AI is reshaping threat surfaces, defense mechanisms, and governance models",
  "Gaps between regulation, compliance frameworks, and real-world implementation",
  "Emerging risks around data protection, privacy, and cross-border digital operations",
  "Structural and talent challenges are limiting long-term cyber resilience",
  "The role of collaboration between institutions, regulators, and technology providers",
];

export const exploresFr = [
  "L’état actuel de la préparation à la cybersécurité dans les secteurs clés",
  "Comment l’IA transforme les surfaces d’attaque, les mécanismes de défense et les modèles de gouvernance",
  "Les écarts entre la réglementation, les cadres de conformité et la mise en œuvre réelle",
  "Les risques émergents liés à la protection des données, à la vie privée et aux opérations numériques transfrontalières",
  "Les défis structurels et liés aux talents limitent la résilience cyber à long terme",
  "Le rôle de la collaboration entre institutions, régulateurs et fournisseurs de technologie",
];

export const research_approachEn = [
  "Regulatory and policy frameworks, including data protection and cybersecurity strategies",
  "Industry and market reports on fintech, AI, and digital transformation",
  "Cyber incident trends and threat intelligence publications",
  "Investment patterns and innovation signals across the region",
];

export const research_approachFr = [
  "Cadres réglementaires et politiques, y compris les stratégies de protection des données et de cybersécurité",
  "Rapports sectoriels et études de marché sur la fintech, l’IA et la transformation numérique",
  "Tendances des incidents cyber et publications sur le renseignement sur les menaces",
  "Modèles d’investissement et signaux d’innovation dans la région",
];

export const report_reasonEn = [
  "Senior leaders in banking, fintech, and digital financial services",
  "Technology, cybersecurity, risk, and compliance professionals",
  "Regulators and policymakers shaping digital governance",
  "Investors, ecosystem builders, and innovation leaders",
];

export const report_reasonFr = [
  "Dirigeants seniors dans la banque, la fintech et les services financiers numériques",
  "Professionnels de la technologie, de la cybersécurité, du risque et de la conformité",
  "Régulateurs et décideurs façonnant la gouvernance numérique",
  "Investisseurs, acteurs de l’écosystème et leaders de l’innovation",
];
